export default __webpack_public_path__ + "static/media/expresso.5a0995cc.png";